"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCustomersApi = activeCustomersApi;
exports.getCreatorListApi = getCreatorListApi;
exports.getMaintainerListApi = getMaintainerListApi;
exports.getMerchantOptionsApi = getMerchantOptionsApi;
exports.getPaymentStatusOptions = getPaymentStatusOptions;
exports.getStatementStatusOptions = getStatementStatusOptions;
exports.getSupplierMaintainerListApi = getSupplierMaintainerListApi;
exports.getUnreconciledDetailApi = getUnreconciledDetailApi;
exports.statementCheckOverlapApi = statementCheckOverlapApi;
exports.statementConfirmApi = statementConfirmApi;
exports.statementCrossMonthOrderListApi = statementCrossMonthOrderListApi;
exports.statementDeleteApi = statementDeleteApi;
exports.statementDetailApi = statementDetailApi;
exports.statementEditDetailApi = statementEditDetailApi;
exports.statementExportApi = statementExportApi;
exports.statementFinancialRemarkApi = statementFinancialRemarkApi;
exports.statementGenerateApi = statementGenerateApi;
exports.statementListApi = statementListApi;
exports.statementLogListApi = statementLogListApi;
exports.statementOrderAddApi = statementOrderAddApi;
exports.statementOrderAddByFilterApi = statementOrderAddByFilterApi;
exports.statementOrderDetailRemarkApi = statementOrderDetailRemarkApi;
exports.statementOrderFilterListApi = statementOrderFilterListApi;
exports.statementOrderListApi = statementOrderListApi;
exports.statementOrderRemoveApi = statementOrderRemoveApi;
exports.statementOrderRemoveByFilterApi = statementOrderRemoveByFilterApi;
exports.statementOrderUpdateApi = statementOrderUpdateApi;
exports.statementPaymentAddApi = statementPaymentAddApi;
exports.statementPaymentConfirmApi = statementPaymentConfirmApi;
exports.statementPaymentDeleteApi = statementPaymentDeleteApi;
exports.statementPaymentDetailApi = statementPaymentDetailApi;
exports.statementPaymentListApi = statementPaymentListApi;
exports.statementPaymentTotalApi = statementPaymentTotalApi;
exports.statementReconciliationRemarkApi = statementReconciliationRemarkApi;
exports.statementRegenerateApi = statementRegenerateApi;
exports.statementRejectApi = statementRejectApi;
exports.statementSettledAfterSaleOrderCountApi = statementSettledAfterSaleOrderCountApi;
exports.statementSettledAfterSaleOrderListApi = statementSettledAfterSaleOrderListApi;
exports.statementSummaryApi = statementSummaryApi;
exports.statementUpdateConfirmApi = statementUpdateConfirmApi;
exports.statementUpdateImportApi = statementUpdateImportApi;
exports.statementUploadMerchantFileApi = statementUploadMerchantFileApi;
exports.unreconciledListApi = unreconciledListApi;
exports.unreconciledMerchantListApi = unreconciledMerchantListApi;
exports.updateStatementOrderItemApi = updateStatementOrderItemApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var BASE_URL = '/admin/merchant/statement';

/**
 * 对账单-分页列表
 * @param {Object} params
 */
function statementListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/list"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-按筛选条件汇总金额
 * @param {Object} params 不包含 page、limit 的列表筛选条件
 * @returns {Promise<Object>} { orderAmount, settlementAmount, actualSettlementAmount, settledPriceDifference }
 */
function statementSummaryApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/summary"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-生成
 * @param {Object} data
 */
function statementGenerateApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/generate"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-详情
 * @param {Number|String} id
 */
function statementDetailApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/detail/").concat(id),
    method: 'get'
  });
}

/**
 * 对账单-编辑回显
 * @param {Number|String} id
 */
function statementEditDetailApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/edit/detail/").concat(id),
    method: 'get'
  });
}

/**
 * 收款详情
 * @param {Number|String} id 对账单ID
 */
function statementPaymentDetailApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/detail/").concat(id),
    method: 'get'
  });
}

/**
 * 对账单-订单明细列表
 * @param {Object} params
 */
function statementOrderListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/list"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-已结算售后订单数量
 * @param {Object} params { statementId }
 */
function statementSettledAfterSaleOrderCountApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/settled-after-sale/count"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-确认
 * @param {Object} data
 */
function statementConfirmApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/confirm"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-驳回
 * @param {Object} data
 */
function statementRejectApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/reject"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-导入更新预校验
 * @param {FormData} data
 */
function statementUpdateImportApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/update/import"),
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}

/**
 * 对账单-确认导入更新
 * @param {FormData} data
 */
function statementUpdateConfirmApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/update/confirm"),
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}

/**
 * 对账单-对账备注
 * @param {Object} data
 */
function statementReconciliationRemarkApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/reconciliation/remark"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-财务备注
 * @param {Object} data
 */
function statementFinancialRemarkApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/financial/remark"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-删除
 * @param {Number|String} id
 */
function statementDeleteApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/delete/").concat(id),
    method: 'delete'
  });
}

/**
 * 对账单-重新生成
 * @param {Number|String} id
 */
function statementRegenerateApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/regenerate/").concat(id),
    method: 'post'
  });
}

/**
 * 对账单-确认打款
 * @param {Object} data
 */
function statementPaymentConfirmApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/confirm"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单列表-按筛选条件导出
 * @param {Object} params 不包含 page、limit 的列表筛选条件
 * @returns {Promise<String|Object>} 文件下载地址或包含文件下载地址的对象
 */
function statementExportApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/export"),
    method: 'get',
    params: params
  });
}

/**
 * 待对账记录-分页列表
 * @param {Object} params
 */
function unreconciledListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/unreconciled/list"),
    method: 'get',
    params: params
  });
}

/**
 * 待对账记录-详情
 * @param {String|Number} id
 */
function getUnreconciledDetailApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/unreconciled/detail/").concat(id),
    method: 'get'
  });
}

/**
 * 商家-自动补全列表
 * @param {String} keyword
 * @param {Number} type 商家类型：1-卡券供应商, 2-实物供应商, 3-家政供应商, 4-核销供应商
 */
function getMerchantOptionsApi(keyword, type) {
  var params = {
    keyword: keyword
  };
  if (type !== undefined && type !== null && type !== '') {
    params.type = type;
  }
  return (0, _request.default)({
    url: '/admin/business/supplier/autoListByType',
    method: 'get',
    params: params
  });
}

/**
 * 对账单-打款明细
 * @param {Object} params
 */
function statementPaymentListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/list"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-日志列表
 * @param {Object} params
 */
function statementLogListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/log/list"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-获取可筛选订单列表
 * @param {Object} params
 */
function statementOrderFilterListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/filter-list"),
    method: 'get',
    params: params
  });
}

/**
 * 对账单-批量添加订单至对账单
 * @param {Object} data
 */
function statementOrderAddApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/add"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-批量从对账单中移除订单
 * @param {Object} data
 */
function statementOrderRemoveApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/remove"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-将筛选结果全部添加至对账单
 * @param {Object} data
 */
function statementOrderAddByFilterApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/add-by-filter"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-将筛选结果全部从对账单中移除
 * @param {Object} data
 */
function statementOrderRemoveByFilterApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/remove-by-filter"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-更新明细行备注
 * @param {Object} data
 */
function statementOrderDetailRemarkApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/detail/remark"),
    method: 'post',
    data: data
  });
}

/**
 * 对账单-编辑订单
 * @param {Object} data
 */
function statementOrderUpdateApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/update"),
    method: 'post',
    data: data
  });
}
function getStatementStatusOptions() {
  return Promise.resolve([{
    label: '已生成',
    value: 0
  }, {
    label: '生成中',
    value: 1
  }, {
    label: '生成失败',
    value: 2
  }]);
}
function getPaymentStatusOptions() {
  return Promise.resolve([{
    label: '未打款',
    value: 0
  }, {
    label: '部分打款',
    value: 1
  }, {
    label: '已打款',
    value: 2
  }]);
}

/**
 * 待对账记录-商家维度聚合列表
 * @param {Object} params
 */
function unreconciledMerchantListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/unreconciled/merchant-list"),
    method: 'get',
    params: params
  });
}

/**
 * 获取供应商维护人列表
 * @param {String} keyword
 */
function getMaintainerListApi(keyword) {
  return (0, _request.default)({
    url: '/admin/business/supplier/maintainer/list',
    method: 'get',
    params: {
      keyword: keyword || undefined
    }
  });
}

/**
 * 获取供应商维护人列表（按供应商去重）
 */
function getSupplierMaintainerListApi() {
  return (0, _request.default)({
    url: '/admin/business/supplier/maintainer/distinct-list',
    method: 'get'
  });
}

/**
 * 获取对账单创建人列表
 * @param {String} keyword
 */
function getCreatorListApi(keyword) {
  return (0, _request.default)({
    url: '/admin/system/admin/autoList',
    method: 'get',
    params: {
      keyword: keyword || undefined
    }
  });
}

/**
 * 对账单-上传商家订单数据
 * @param {FormData} data
 */
function statementUploadMerchantFileApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/upload-merchant-file"),
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}

/**
 * 对账单-检查账单周期内是否存在重叠订单
 * @param {Object} params
 */
function statementCheckOverlapApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/check-overlap"),
    method: 'get',
    params: params
  });
}

/**
 * 生成对账单-已结算售后订单列表
 * @param {Object} params { merchantId, periodStart, periodEnd }
 */
function statementSettledAfterSaleOrderListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/settled-after-sale-order/list"),
    method: 'get',
    params: params
  });
}

/**
 * 生成对账单-跨月订单分页列表
 * @param {Object} params { merchantId, periodStart, periodEnd, page, limit }
 */
function statementCrossMonthOrderListApi(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/cross-month-order/list"),
    method: 'get',
    params: params
  });
}

/**
 * 打款明细-添加
 * @param {Object} data
 */
function statementPaymentAddApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/add"),
    method: 'post',
    data: data
  });
}

/**
 * 打款明细-删除
 * @param {Number|String} id
 */
function statementPaymentDeleteApi(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/delete/").concat(id),
    method: 'delete'
  });
}

/**
 * 打款明细-获取打款总金额
 * @param {Number|String} statementId
 */
function statementPaymentTotalApi(statementId) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/payment/total"),
    method: 'get',
    params: {
      statementId: statementId
    }
  });
}

/**
 * 对账单-更新订单项结算明细
 * @param {Object} data
 */
function updateStatementOrderItemApi(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/order/detail/item/update"),
    method: 'post',
    data: data
  });
}

/**
 * 有效商家列表
 */
function activeCustomersApi() {
  return (0, _request.default)({
    url: '/admin/customers/active-customers',
    method: 'get'
  });
}